module.exports = __webpack_public_path__ + "files/367f92d45af835c3ef602aea86b46d8a.png";